import { makeStyles } from "@material-ui/core/styles";
import * as colors from "../../theme/colors";

export const useNavBarStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    height: 65,
  },
  menuButton: {
    marginRight: theme.spacing(2),
    color: colors.darkThemeBlue,
  },
  appBar: {
    height: 65,
    boxShadow: "none",
    minWidth: "100%",
    background: (props) => props.navBackGroundColor,
    "&:hover": {
      background: colors.lightGradient,
    },
  },
  toolbar: {
    height: 65,
    [theme.breakpoints.down("xl")]: {
      paddingRight: 10,
      paddingLeft: 15,
    },
  },
  buttonsBox: {
    display: "flex",
    justifyContent: "flex-end",
    color: colors.darkBlue900,
    alignSelf: "center",
    height: "100%",
  },
  logoContainer: {
    display: "flex",
    justifyContent: "flex-start",
    [theme.breakpoints.down("md")]: {
      justifyContent: "center",
    },
  },
  mobileLogoContainer: {
    display: "flex",
    justifyContent: "center",
  },
  menuItemBox: {
    "&.Mui-focusVisible": {
      outline: `2px dotted ${colors.grey400}`,
      outlineOffset: -2,
    },
  },
  globeIcon: {
    marginTop: -2,
    marginRight: 7,
  },
  langCheckIcon: {
    marginTop: -2,
    marginRight: 10,
    color: colors.lightThemeGreen,
  },
  langSpacer: {
    width: 33,
    height: 10,
    display: "inline-block",
  },
  loginButton: {
    width: "100px",
    [theme.breakpoints.up("xl")]: {
      width: "120px",
    },
  },
  mainContentLink: {
    position: "absolute",
    top: "0px",
    left: "0px",
  },
  codeJamLogo: {
    display: "flex",
    "& > img": {
      width: 120,
      maxHeight: 40,
      alignSelf: "center",
      [theme.breakpoints.up("xl")]: {
        marginRight: 10,
      },
    },
  },
}));
